<template>
	<div class="leftO">
		<breadcrumb :routerList="[{to:'/xiangmu/pm',title:'费用管理'},{title:'详情'}]" />
		<div class="left">
			<div class="left3">
				<span class="xunjia">特价信息</span>
				<div class="zhongbiao">
					<div class="zhongbiaoWrapper clear">
						<div class="left4">
							<span class="spanN">项目编号</span>
							<span class="spanT">SHKKLH987</span>
						</div>
						<div class="left4">
							<span class="spanN">中标状态</span>
							<span class="spanT">已中标</span>
						</div>
						<div class="left4">
							<span class="spanN">产品大类</span>
							<span class="spanT">超低温冷柜</span>
						</div>
						<div class="left4">
							<span class="spanN">产品型号</span>
							<span class="spanT">SHKKLH987</span>
						</div>
						<div class="left4">
							<span class="spanN">产品数量</span>
							<span class="spanT">10(台)</span>
						</div>
						<div class="left4">
							<span class="spanN">供货价格</span>
							<span class="spanT">51.0000(元)</span>
						</div>
						<div class="left4">
							<span class="spanN">发起人工号</span>
							<span class="spanT">51.0000(元)</span>
						</div>
					</div>
				</div>
			</div>
			<div class="left3">
				<span class="xunjia">基本信息</span>
				<div class="zhongbiao">
					<div class="zhongbiaoWrapper clear">
						<div class="left4">
							<span class="spanN">项目编号</span>
							<span class="spanT">SHKKLH987</span>
						</div>
						<div class="left4">
							<span class="spanN">中标状态</span>
							<span class="spanT">已中标</span>
						</div>
						<div class="left4">
							<span class="spanN">产品大类</span>
							<span class="spanT">超低温冷柜</span>
						</div>
						<div class="left4">
							<span class="spanN">单型号费用</span>
							<span class="spanT">SHKKLH987</span>
						</div>
						<div class="left4">
							<span class="spanN">产品数量</span>
							<span class="spanT">10(台)</span>
						</div>
					</div>
				</div>
			</div>
		</div>
		
		<div class="enter">
			<el-row>
				<el-button type="primary">返 回</el-button>
			</el-row>
		</div>
	</div>
</template>
<script>
	export default {
		data() {
			return {
				radio: '',
				formLabelAlign: {
					name: '',
					contact: '',
					contactInfo: '',
					type: '',
					date3: '',
					explain: ''
				},
				form: {
					name: '',
					region: '',
					date1: '',
					date2: '',
					delivery: false,
					type: [],
					resource: '',
					desc: ''
				}
			}
		},
		methods: {
			onSubmit() {
				// console.log('submit!');
			}
		}
	}
</script>
<style scoped>
	.clear::after {
		content: '';
		display: block;
		width: 0;
		height: 0;
		clear: both;
	}
	.left {
		width: 95%;
		background-color: rgb(255, 255, 255);
		padding: 20px;
		margin: 35px;
		border: 1px solid #E2E2E2;
	}
	.xunjia {
		color: #0e75e9;
		display: inline-block;
		padding-left: 10px;
		border-left: 5px solid #0e75e9;
		font-weight: bold;
		font-size: 18px;
		margin-bottom: 30px;
	}
	.zhongbiao {
		margin-left: 20px;
		overflow: hidden;
	}
	.zhongbiaoWrapper {
		margin-right: -20px;
	}
	.left4 {
		width: 50%;
		float: left;
		margin-bottom: 30px;
		display: flex;
		align-items: center;
	}
	.spanN {
		width: 85px;
		margin-right: 25px;
		text-align: right;
	}
	.spanT {
		width: 65%;
		border-bottom: 1px solid #E2E2E2;
		padding-bottom: 10px;
		color: #8A8A8A;
		text-indent: 1em;
	}
	.enter {
	    text-align: center;
	}
	.enter .el-button {
		padding: 18px 43px;
	}
</style>
<style>
	.h-formbLine2 .el-form-item__label {
		width: 26% !important;
	}

	.h-formbLine2 .el-form-item__content {
		width: 74% !important;
	}
</style>
